"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _runtime = require("../runtime");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = (0, _runtime.IconWrapper)('cone', function (props) {
  return _react.default.createElement("svg", {
    width: props.size,
    height: props.size,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, _react.default.createElement("path", {
    d: "M42 39C42 41.7614 33.9411 44 24 44C14.0589 44 6 41.7614 6 39C6 38.5107 6.25301 38.0378 6.72466 37.5909C8.91494 35.5156 15.8203 34 24 34C32.1797 34 39.0851 35.5156 41.2753 37.5909C41.747 38.0378 42 38.5107 42 39Z",
    fill: props.outFillColor
  }), _react.default.createElement("path", {
    d: "M6.72466 37.5909C8.91494 35.5156 15.8203 34 24 34C32.1797 34 39.0851 35.5156 41.2753 37.5909L24 4L6.72466 37.5909Z",
    fill: props.outFillColor
  }), _react.default.createElement("path", {
    d: "M42 39C42 41.7614 33.9411 44 24 44C14.0589 44 6 41.7614 6 39M42 39L41.2753 37.5909M42 39C42 38.5107 41.747 38.0378 41.2753 37.5909M6 39L6.72466 37.5909M6 39C6 38.5107 6.25301 38.0378 6.72466 37.5909M6.72466 37.5909C8.91494 35.5156 15.8203 34 24 34C32.1797 34 39.0851 35.5156 41.2753 37.5909M6.72466 37.5909L24 4L41.2753 37.5909",
    stroke: props.outStrokeColor,
    strokeWidth: props.strokeWidth,
    strokeLinecap: props.strokeLinecap,
    strokeLinejoin: props.strokeLinejoin
  }));
});

exports.default = _default;